/**
 * Enum for user state values.
 * @readonly
 * @enum {string}
 */

export enum UserAction {
  UPDATE_USER = 'updateUser',
  UPDATE_TOKEN = 'updateToken',
  UPDATE_PRODUCTS = 'updateProducts',
  UPDATE_CLASSES = 'updateClasses',
  UPDATE_CURRICULA = 'updateCurricula',
}
export function getUserActions(): UserAction[] {
  return [UserAction.UPDATE_USER, UserAction.UPDATE_TOKEN, UserAction.UPDATE_PRODUCTS, UserAction.UPDATE_CLASSES, UserAction.UPDATE_CURRICULA];
}
export function getUserActionFrom(value: string): UserAction | undefined {
  return getUserActions().find(type => type === value);
}